module.exports = __webpack_public_path__ + "static/media/07.98c25e3f.mp3";